const style = theme => ({
  content: {
    overflow: 'unset',
  },
  text: {
    marginBottom: theme.spacing(),
  },
  container: {
    height: '100%',
    display: 'flex',
    flexFlow: 'column',
  },
});

export default style;
